/**
 * Deep-link to Outlook on the web for a mailbox UPN (shared or user).
 * Shows folder tree (Inbox, Archive, etc.) when the browser session has access.
 *
 * Override host for sovereign clouds / special tenants:
 *   REACT_APP_MICROSOFT_OWA_MAIL_BASE=https://outlook.office365.com/mail
 */
const DEFAULT_OWA_MAIL_BASE = "https://outlook.office365.com/mail";

/**
 * @param {string} mailboxEmail — e.g. shared@company.com
 * @returns {string|null}
 */
export function buildOutlookWebMailboxUrl(mailboxEmail) {
  const email = String(mailboxEmail || "").trim();
  if (!email) return null;

  const raw =
    (typeof process !== "undefined" && process.env.REACT_APP_MICROSOFT_OWA_MAIL_BASE) ||
    DEFAULT_OWA_MAIL_BASE;
  const base = String(raw).replace(/\/+$/, "");

  return `${base}/${encodeURIComponent(email)}`;
}
